import moment from 'moment-timezone'
import Vue2Filters from 'vue2-filters'

const number = v => (v || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const date = (value, opt = 'YYYY.MM.DD') => (value && moment(value).format(opt) || '-');
const datetime = (value, opt = 'YYYY.MM.DD HH:mm:ss') => (value && moment(value).format(opt) || '-');
const datetime2 = (value, opt = 'YYYY.MM.DD HH:mm') => (value && moment(value).format(opt) || '-');
const utcDatetime = (value, opt = 'YYYY.MM.DD HH:mm:ss') => (value && (moment(value).utc().format(opt)) || '-');
const sdate = (value) => value && moment(value).format(moment().startOf('d').isSame(moment(value).startOf('d')) ? 'HH:mm' : 'YYYY.MM.DD') || '-';

const limit = (value, opt = 'YYYY.MM.DD HH:mm:ss') => (value && moment(value).format(opt) || '-');

const GB = (v=0) => { return v ? (v / 1024 / 1024 / 1024).toFixed(2) + ' GB' : 0 }
const MB = (v=0) => { return v ? (v / 1024 / 1024).toFixed(2) + ' MB' : 0 }
const KB = (v=0) => { return v ? (v / 1024).toFixed(2) + ' KB' : 0 }

const bytes = (v=10000) => {
  // return v
  if(v < 1024) { return number(v) }
  if(v < 1024 * 1024) { return KB(v) }
  if(v < 1024 * 1024 * 1024) { return MB(v) }
  return GB(v)
}

var Filter = {
  install: function(Vue) {
    Vue.use(Vue2Filters);

    Vue.filter('number', number);

    Vue.filter('date', date);
    Vue.filter('datetime', datetime);
    Vue.filter('datetime2', datetime2);
    Vue.filter('utcDatetime', utcDatetime);
    Vue.filter('sdate', sdate);

    Vue.filter('GB', GB);
    Vue.filter('MB', MB);
    Vue.filter('bytes', bytes);

    Vue.filter('limit', limit);
  }
}

export default Filter;

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Filter);
}
